import { LayoutHeader, ProductHeader, WorkspaceHeader } from '@dms/component'
import { FeedbackTable } from '@dms/component/feedback'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { Link, useNumberParams } from 'zens-router'
import { Button, Color, Radius, Spacing } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const FeedbackList = () => {
  const [{ companyId, locationId, productId, workspaceId, commentId, photoId }, setNumberParams] = useNumberParams()
  const { t } = useTranslation()

  function show(params: { commentId?: number; photoId?: number } | undefined) {
    setNumberParams(params || { commentId: undefined, photoId: undefined })
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton title breadcrumb accessory={<Button.Skeleton />} />}>
        {productId ? (
          <ProductHeader
            companyId={companyId}
            productId={productId}
            title={t('Remarks')}
            breadcrumbItems={[{ title: t('Remarks') }]}
            accessory={
              locationId ? (
                <Link
                  href={{
                    pathname: `/companies/${companyId}/feedback/add`,
                    params: { locationId, productId, workspaceId },
                  }}
                  asChild
                >
                  <Button title={t('Add remark')} left="plus" testID="FeedbackList.Add" />
                </Link>
              ) : undefined
            }
          />
        ) : workspaceId ? (
          <WorkspaceHeader
            companyId={companyId}
            workspaceId={workspaceId}
            title={t('Remarks')}
            breadcrumbItems={[{ title: t('Remarks') }]}
            accessory={
              locationId ? (
                <Link
                  href={{
                    pathname: `/companies/${companyId}/feedback/add`,
                    params: { locationId, productId, workspaceId },
                  }}
                  asChild
                >
                  <Button title={t('Add remark')} left="plus" testID="FeedbackList.Add" />
                </Link>
              ) : undefined
            }
          />
        ) : null}
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<FeedbackTable.Skeleton />}>
          <FeedbackTable
            companyId={companyId}
            productId={productId}
            workspaceId={workspaceId}
            commentId={commentId}
            photoId={photoId}
            onSelect={show}
          />
        </Suspense>
      </View>
    </View>
  )
}

export default FeedbackList
